import React from 'react';

import { RadioButton as PrimeReactRadioButton } from 'primereact/radiobutton';


const RadioButton: React.FC<any> = (props): JSX.Element => {
    const { field, value, label, ...passThroughProps } = props;

    return (
        <div className="p-col-12 radio-button">
            <PrimeReactRadioButton inputId={value} value={value}
                checked={field === value} {...passThroughProps} />
            <label htmlFor={value} className="p-radiobutton-label">
                {label}
            </label>
        </div>
    );
}

export default RadioButton;
